import { WeezHeader } from '@weezevent/nacre';
import React, { useState, useEffect, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import moment from 'moment/moment';
import { makeAutoObservable } from 'mobx';
import { main } from './state';
import { useTranslation } from 'react-i18next';
import css from './styles.module.css';

import Waiting from './components/Waiting';
import Steps from './components/Steps';
import Unavailable from './components/Unavailable';

const InvitationsLight = observer(({ organization, event }) => {
    const { t } = useTranslation();
    const { loading, ready } = main;
    main.use({ organization, event });

    return (
        <div id="invitations-light">
            <Waiting for={!loading}>
                <WeezHeader title={t('attendees.invitations.title')}>{t('attendees.invitations.subtitle')}</WeezHeader>
                {ready ? <Steps /> : <Unavailable />}
            </Waiting>
        </div>
    );
});

export default InvitationsLight;

export { PropTypes, moment, observer, useTranslation, makeAutoObservable, React, useState, useEffect, useCallback, useMemo, Waiting, css };
export { default as i18n } from 'i18next';
export { main } from './state';
